import styles from './styles';

import * as React from 'react';

import { action, computed } from 'mobx';
import { Provider, inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';

import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type HistoryStore from 'connect/web/src/stores/history-store';
import type ProviderStore from 'connect/web/src/stores/provider-store';
import Nav from './controls/nav';
import HeaderStore from './stores/header-store';

interface IProps extends WithStyles<typeof styles> {
  historyStore?: HistoryStore;
  providerStore?: ProviderStore;
}

@inject('historyStore', 'providerStore')
@observer
class Header extends React.Component<IProps> {
  readonly headerStore: HeaderStore = new HeaderStore();

  render() {
    const { embeddedMode, logoUrl, showSiteTitle, siteTitle } = this.props.providerStore!;
    const { classes } = this.props;

    if (embeddedMode) {
      return null;
    }

    const { toggleMenu } = this.headerStore;

    let header;
    if (!!siteTitle && !!showSiteTitle) {
      header = (
        <h1 className={this.titleClass} onClick={this.onClick}>
          {siteTitle}
        </h1>
      );
    }

    let logo;
    if (!!logoUrl) {
      logo = (
        <a className={classes.logo} onClick={this.onClick}>
          <img alt={siteTitle} src={this.imageLocation} />
        </a>
      );
    }

    return (
      <div className={classes.desktopHeader}>
        <div className={classes.headerBar}>
          {logo}
          {header}
          <div
            role="button"
            aria-label="navigation menu"
            tabIndex={1}
            className={classes.menuButton}
            onClick={toggleMenu}
          >
            <FontAwesomeIcon icon={faBars} />
          </div>
          <Provider headerStore={this.headerStore}>
            <Nav />
          </Provider>
        </div>
      </div>
    );
  }

  @computed
  get imageLocation(): string | undefined {
    const { logoUrl } = this.props.providerStore!;
    if (!logoUrl) {
      return undefined;
    }
    return `/api/online/files/bypath/${logoUrl}`;
  }

  @computed
  get titleClass(): string {
    const { title, long, short, leftTitle } = this.props.classes;
    const { siteTitle, logoUrl } = this.props.providerStore!;

    const classNames = [title];

    if (siteTitle.length > 20) {
      classNames.push(long);
    } else if (siteTitle.length < 10) {
      classNames.push(short);
    }

    if (!logoUrl) classNames.push(leftTitle);

    return classNames.join(' ');
  }

  @action.bound
  private onClick(): void {
    this.props.historyStore!.push('');
  }
}

export default withStyles(styles)(Header);
